import React from 'react';
import styled from 'styled-components';
import * as size from '@constant/size';
import * as color from '@constant/color';
import TextBlock from '@component/common/block/text-block';
import Gap from '@component/common/gap';
import ImageAudioButton from '@design-system/image-audio-button';
import Canvas from '@design-system/canvas';
import { ETheme } from '@datatype/type';
import { replaceDashWithTilde } from '@util/string';

interface IProps {
  keyword: string;
  pronunciation: string;
  meaning: string;
  keywordAudioLink: string | null;
}

const Wrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 100%;
`;

const WelcomeContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`;

const KeywordCardContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`;

const ConversationKeyword: React.FC<IProps> = ({ keyword, pronunciation, meaning, keywordAudioLink }) => {
  const normalizedKeyword = replaceDashWithTilde(keyword);
  return (
    <Wrapper>
      <WelcomeContainer>
        <TextBlock
          text={'이 어휘와 더 친해져 볼까요?'}
          design={{ text: { size: 'large', color: color.BLACK_2, bold: true }, box: { alignX: 'center' } }}
        />
        <TextBlock
          text={'대화로 배우면 진짜 내 어휘가 돼요'}
          design={{ text: { size: 'medium', color: color.GRAY_1, bold: false }, box: { alignX: 'center' } }}
        />
      </WelcomeContainer>
      <Gap height={size.MARGIN_1} />
      <Canvas theme={ETheme.BROWN} shape='round' width='100%' padding={size.MARGIN_1}>
        <KeywordCardContainer>
          <TextBlock
            text={normalizedKeyword}
            annotation={pronunciation ? { reading: pronunciation } : undefined}
            design={{
              text: { size: 'big', color: color.BLACK_2, bold: true },
              box: { alignX: 'center' },
            }}
          />
          <TextBlock
            text={replaceDashWithTilde(meaning)}
            design={{
              text: { size: 'large', color: color.BROWN_1, bold: true },
              box: { alignX: 'center' },
            }}
          />
          {keywordAudioLink && (
            <>
              <Gap height={'5px'} />
              <ImageAudioButton
                theme={ETheme.BROWN}
                kind='outlined'
                size='small'
                shape='round'
                width='fit-content'
                sources={[keywordAudioLink]}
              />
            </>
          )}
        </KeywordCardContainer>
      </Canvas>
    </Wrapper>
  );
};

export default ConversationKeyword;
